import { render, staticRenderFns } from "./ContractorRoleEdit.vue?vue&type=template&id=4c663bb1&scoped=true&"
import script from "./ContractorRoleEdit.vue?vue&type=script&lang=js&"
export * from "./ContractorRoleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c663bb1",
  null
  
)

export default component.exports